import { monthList } from '@/const/mounth'

export function mounthFormat (data) {
  return monthList.find(mounth => mounth.id === data)
}
